export enum KakaotalkTemplateCategoryEnum {
  FRIENDSTALK = 'friendstalk',
}
